import script from "./HandlebarFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./HandlebarFilters.vue?vue&type=script&setup=true&lang=ts"

import "./HandlebarFilters.vue?vue&type=style&index=0&id=35841a6f&lang=scss"

const __exports__ = script;

export default __exports__